import React from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import { selectLoggedIn } from "../store/slices/authRecipient/slice";

const UserLayout = () => {
  const location = useLocation();
  const loggedIn = useSelector(selectLoggedIn);

  return loggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default UserLayout;
